var map = {
	"./featured-item/coach@2x.webp": 167,
	"./featured-item/cuff@2x.webp": 171,
	"./featured-item/fastclix_lancets@2x.webp": 175,
	"./featured-item/fastclix_lancing_kit@2x.webp": 179,
	"./featured-item/guide@2x.webp": 183,
	"./featured-item/guide_me@2x.webp": 187,
	"./featured-item/mysugr_coach_voucher_based_1@2x.webp": 191,
	"./featured-item/pro@2x.webp": 195,
	"./featured-item/scale@2x.webp": 199,
	"./featured-item/softclix_lancets@2x.webp": 203,
	"./featured-item/softclix_lancing_kit@2x.webp": 207,
	"./featured-item/strips_subscription_guide@2x.webp": 211,
	"./item/coach@2x.webp": 294,
	"./item/cuff@2x.webp": 296,
	"./item/fastclix_lancets@2x.webp": 298,
	"./item/fastclix_lancing_kit@2x.webp": 300,
	"./item/guide@2x.webp": 302,
	"./item/guide_me@2x.webp": 304,
	"./item/guide_strips@2x.webp": 306,
	"./item/mysugr_coach_voucher_based_1@2x.webp": 308,
	"./item/pro@2x.webp": 310,
	"./item/scale@2x.webp": 312,
	"./item/softclix_lancets@2x.webp": 314,
	"./item/softclix_lancing_kit@2x.webp": 316,
	"./item/strips_subscription_guide@2x.webp": 318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 685;